import { Text } from '../Text'
import { Column, Row } from '../Grid'
import { NextImage } from '../NextImage'

import { useUser } from 'providers/UserProvider'
import { getDataContractId, getContractFeatureValue } from 'utils/helpers'

const PsychoPrice = ({ contractPrice, originalPrice, showPaymentMethodMessage }) => {
  const dataContractId = getDataContractId()
  const { shouldHideConsultationValue: profileShouldHideConsultationValue, isUserB2B } = useUser()

  const isB2BUser = !!(isUserB2B || dataContractId?.integration?.contract?.id)
  const shouldHideOriginalPrice = !!(
    profileShouldHideConsultationValue ||
    getContractFeatureValue(dataContractId, 'hide_consultation_value')
  )

  const hasContractValueToBePaid = contractPrice > 0
  const originalTextStyle = showPaymentMethodMessage ? 'primary' : 'default'

  if (!isB2BUser || originalPrice === contractPrice)
    return (
      <Column>
        <Text
          textAlign='center'
          fontSize={ORIGINAL_PRICE_STYLES[originalTextStyle]?.fontSize}
          fontWeight={ORIGINAL_PRICE_STYLES[originalTextStyle]?.fontWeight}
          color={ORIGINAL_PRICE_STYLES[originalTextStyle]?.color}
        >
          R$ {formatPrice(originalPrice)}
        </Text>
        {showPaymentMethodMessage && <PaymentMethodMessage />}
      </Column>
    )

  if (hasContractValueToBePaid || !shouldHideOriginalPrice) {
    return (
      <Column>
        {shouldHideOriginalPrice ? (
          <Text color='green' fontWeight='600' fontSize={['1.5rem', '1.5rem', '2rem']}>
            R$ {formatPrice(contractPrice)}
          </Text>
        ) : (
          <>
            <Column width='100%'>
              <Text
                color='gray.n400'
                textDecoration='line-through'
                fontSize={['1rem', '1rem', '1.5rem']}
              >
                R$ {formatPrice(originalPrice)}
              </Text>
            </Column>
            <Column width='100%'>
              <Text color='green' fontWeight='600' fontSize={['1.5rem', '1.5rem', '2rem']}>
                R$ {formatPrice(contractPrice)}
              </Text>
            </Column>
          </>
        )}
        {showPaymentMethodMessage && <PaymentMethodMessage />}
      </Column>
    )
  }

  return (
    typeof contractPrice !== 'string' && (
      <Column>
        <Text
          textAlign='center'
          fontSize={ORIGINAL_PRICE_STYLES[originalTextStyle]?.fontSize}
          fontWeight={ORIGINAL_PRICE_STYLES[originalTextStyle]?.fontWeight}
          color={ORIGINAL_PRICE_STYLES[originalTextStyle]?.color}
        >
          R$ {Number(originalPrice)}
        </Text>
        {showPaymentMethodMessage && <PaymentMethodMessage />}
      </Column>
    )
  )
}

export default PsychoPrice

const PaymentMethodMessage = () => {
  return (
    <Row maxWidth='160px' width='100%'>
      <Column width='25px' gridGap='16px' mr='16px' mt='8px'>
        <NextImage height={16} width={16} src='/static/images/bill.svg' alt='' />
        <NextImage height={16} width={16} src='/static/images/credit-card.svg' alt='' />
      </Column>
      <Column>
        <Text textAlign='left' color='lightGray' fontSize={['0.75rem', '0.75rem', '1rem']}>
          pagamentos via cartão ou boleto
        </Text>
      </Column>
    </Row>
  )
}

const ORIGINAL_PRICE_STYLES = {
  primary: {
    fontSize: ['1rem', '1rem', '1.5rem'],
    fontWeight: '400',
    color: 'primary'
  },
  default: {
    fontSize: ['1.5rem', '1.5rem', '2rem'],
    fontWeight: '600'
  }
}

const formatPrice = price => {
  if (price === null || price === undefined) return '...'
  return Number(price)
}
